import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import BackupList from '../components/backup/BackupList';
import ConfigPanel from '../components/backup/ConfigPanel';
import RestorePanel from '../components/backup/RestorePanel';
import BackupJobStatus from '../components/backup/BackupJobStatus';
import BackupActionsToolbar from '../components/backup/BackupActionsToolbar';
import BackupTabs from '../components/backup/BackupTabs';
import { useBackupOperations } from '../components/backup/hooks/useBackupOperations';

const Backup: React.FC = () => {
  const [activeTab, setActiveTab] = useState('backups');
  const {
    loading,
    selectedBackups,
    backups,
    backupConfig,
    job,
    setBackupConfig,
    fetchBackups,
    saveBackupConfig,
    createBackup,
    restoreBackup,
    handleBackupSelect,
    handleBulkAction,
    hideJob,
  } = useBackupOperations();

  const renderTabContent = () => {
    switch (activeTab) {
      case 'backups':
        return (
          <div className="space-y-6">
            <BackupActionsToolbar
              loading={loading}
              selectedBackups={selectedBackups}
              backupsCount={backups.length}
              onCreateBackup={() => createBackup()}
              onBulkAction={handleBulkAction}
              onRefresh={fetchBackups}
            />
            <BackupList
              backups={backups}
              loading={loading}
              selectedBackups={selectedBackups}
              onBackupSelect={handleBackupSelect}
              onBulkAction={handleBulkAction}
              onRestoreBackup={restoreBackup}
            />
          </div>
        );

      case 'config':
        return (
          <ConfigPanel
            config={backupConfig}
            loading={loading}
            onConfigChange={setBackupConfig}
            onSaveConfig={saveBackupConfig}
          />
        );

      case 'restore':
        return <RestorePanel backups={backups} loading={loading} onRestoreBackup={restoreBackup} />;

      default:
        return null;
    }
  };

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold text-slate-900 dark:text-slate-100">Backup & Restore</h1>
        <p className="mt-2 text-slate-600 dark:text-slate-400">
          Manage DNS zone backups and restore operations
        </p>
      </div>

      <BackupJobStatus job={job} onHide={hideJob} />

      <div className="bg-white dark:bg-slate-800 shadow-sm rounded-lg">
        <div className="grid grid-cols-1 lg:grid-cols-5">
          <div className="lg:col-span-1 bg-slate-50 dark:bg-slate-900/50 rounded-l-lg">
            <BackupTabs activeTab={activeTab} onTabChange={setActiveTab} />
          </div>

          <div className="lg:col-span-4 p-6">
            <AnimatePresence mode="wait">
              <motion.div
                key={activeTab}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.2 }}
              >
                {renderTabContent()}
              </motion.div>
            </AnimatePresence>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Backup;
